import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FileService {
    private path = environment.apiUrl;
    constructor(private http: HttpClient) {}

    upload(file: any) {
        // Here implement the file form-data upload
        // requires admin user
        return this.http.post<UploadedFile>(`${this.path}/admin/files/public-upload`, file);
    }

    download(fileName: string) {
        // requires admin user
        return this.http.get(`${this.path}/admin/files/download/${fileName}`);
    }
}

interface UploadedFile {
    fieldname: string;
    originalname: string;
    encoding: string;
    mimetype: string;
    id: string;
    filename: string;
    metadata: any;
    bucketName: string;
    chunkSize: number;
    size: number;
    uploadDate: Date;
    contentType: string;
    // concatenate this to the api path to get the file
    url: string;
}
